import { Component } from '@angular/core';
import { ChatCardComponent } from '../common/chat-card/chat-card.component';

@Component({
  selector: 'app-settings',
  imports: [ChatCardComponent],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {}
